// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d05998d0","885":"1fa4a646","977":"61bd5786"}[chunkId] + ".chunk.js";
};